export default __webpack_public_path__ + "static/media/airtable.05558d76.svg";